import * as React from 'react';
import { CnStatusTag } from '@/components/cn-tag';
import { withNativeProps } from '@/utils/with-native-props';
import './index.scss';
const renderDescription = (description) => {
    const result = [];
    if (Array.isArray(description)) {
        description.forEach((descriptionItem) => {
            result.push(React.createElement("div", { className: "cn-ui-m-detail-info-description-item" }, descriptionItem));
        });
    }
    else {
        result.push(React.createElement("div", { className: "cn-ui-m-detail-info-description-item" }, description));
    }
    return result;
};
/**
 * @category 组件
 * @description 详情摘要信息展示卡片
 */
export const CnDetailInfo = (props) => {
    const { title, description, status, tagText, cnStatusTagProps, avatar } = props;
    return withNativeProps(props, React.createElement("div", { className: "cn-ui-m-detail-info" },
        avatar && React.createElement("img", { className: "cn-ui-m-detail-info-avatar", src: avatar }),
        React.createElement("div", { className: "cn-ui-m-detail-info-description" },
            React.createElement("div", { className: "cn-ui-m-detail-info-description-hd" },
                React.createElement("div", { className: "cn-ui-m-detail-info-description-title" }, title),
                status && (React.createElement("div", { className: "cn-ui-m-detail-info-description-tag" },
                    React.createElement(CnStatusTag, { status: status, ...cnStatusTagProps }, tagText)))),
            React.createElement("div", { className: "cn-ui-m-detail-info-description-ft" }, renderDescription(description)))));
};
CnDetailInfo.displayName = 'CnDetailInfo';
CnDetailInfo.defaultProps = {};
